<!--
 * @Author: your name
 * @Date: 2020-08-18 15:03:25
 * @LastEditTime: 2020-08-21 15:21:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/views/payroll/wage/step1.vue
-->
<template>
  <div class="panel">
    <!-- 基本信息 -->
    <div class="divider">{{ $t('312') }}</div>
    <!-- 员工属性 -->
    <el-form-item :label="$t('32')">
      <el-select disabled v-model="staffInfo.staff_formal" placeholder="">
        <el-option v-for="item in sysInfo.formal" :key="item.value" :label="item.value" :value="item.key"></el-option>
      </el-select>
    </el-form-item>
    <!-- 员工属性 -->
    <el-form-item :label="$t('31')">
      <el-select disabled v-model="staffInfo.staff_state" placeholder="">
        <el-option v-for="item in sysInfo.state" :key="item.value" :label="item.value" :value="item.key"></el-option>
      </el-select>
    </el-form-item>
    <!-- 发薪方式 -->
    <el-form-item :label="$t('34')">
      <el-select disabled v-model="staffInfo.pay_method" placeholder="">
        <el-option
          v-for="item in sysInfo.salary_method"
          :key="item.value"
          :label="item.value"
          :value="item.key"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- 结算类型 -->
    <el-form-item :label="$t('33')">
      <el-select disabled v-model="staffInfo.settlement_type" placeholder="">
        <el-option
          v-for="item in sysInfo.settlement_type"
          :key="item.value"
          :label="item.value"
          :value="item.key"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- 电话 -->
    <el-form-item :label="$t('23')">
      <el-input disabled v-model="staffInfo.staff_phone" placeholder=""></el-input>
    </el-form-item>
    <!-- 月结：1、日结：2、其他：99 -->
    <template v-if="staffInfo.settlement_type != 99">
      <!-- 扣税 -->
      <el-form-item :label="$t('421')" prop="tax_deduction_status">
        <el-select
          :disabled="show"
          v-model="staffInfo.tax_deduction_status"
          :placeholder="$t('221')"
          @change="changeTaxDeduction"
        >
          <el-option
            v-for="item in taxDeductionConfig"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- Tax ID -->
      <el-form-item :label="$t('429')" prop="tax_id">
        <el-input
          :disabled="show"
          v-model="staffInfo.tax_id"
          placeholder=""
          maxlength="13"
          @blur="taxIdBlur(staffInfo.tax_id)"
        ></el-input>
      </el-form-item>
      <!-- 社保状态 -->
      <el-form-item :label="$t('427')" prop="social_security_status">
        <el-select :disabled="show" v-model="staffInfo.social_security_status" :placeholder="$t('221')">
          <el-option
            v-for="item in socialSatausConfig"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 银行信息 -->
      <el-form-item key="bank_card_no1" :label="$t('426')" prop="bank_card_no">
        <el-input
          placeholder=""
          v-model="staffInfo.bank_card_no"
          v-enterIntNumber
          :maxlength="max"
          :minlength="min"
          class="input-with-select"
          :disabled="show"
        >
          <el-select :disabled="show" v-model="staffInfo.bank_name" slot="prepend" style="width: 120px" placeholder="">
            <el-option v-for="item in bankConfig" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <!-- 公积金状态 -->
      <el-form-item :label="$t('1709')" prop="provident_fund_status">
        <el-select :disabled="show" v-model="staffInfo.provident_fund_status">
          <el-option
            v-for="item in accumulationFundEnum"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 收入类型 预扣税4显示 -->
      <template v-if="+staffInfo.tax_deduction_status === 4">
        <el-form-item prop="income_type">
          <template slot="label">
            <span>{{ $t('1980') }}</span>
            <el-tooltip class="item" effect="dark" :content="$t('1981')" placement="top-start">
              <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
            </el-tooltip>
          </template>
          <el-input v-model="staffInfo.income_type" :disabled="show"></el-input>
        </el-form-item>
      </template>
    </template>
    <template v-if="staffInfo.settlement_type == 99">
      <!-- 银行信息 -->
      <el-form-item key="bank_card_no2" :label="$t('426')" prop="bank_card_no">
        <el-input
          placeholder=""
          v-model="staffInfo.bank_card_no"
          v-enterIntNumber
          maxlength="12"
          class="input-with-select"
          :disabled="show"
        >
          <el-select :disabled="show" v-model="staffInfo.bank_name" slot="prepend" style="width: 120px" placeholder="">
            <el-option v-for="item in bankConfig" :key="item.value" :label="item.text" :value="item.value"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <!-- 收入 -->
      <el-form-item :label="$t('473')">
        <el-input v-model="staffInfo.salary_month" v-enterNumberPoint2 v-enterNumberMax="1000000000" placeholder="0.00">
        </el-input>
      </el-form-item>
    </template>
  </div>
</template>
<script>
import { socialSatausConfig, taxDeductionConfig, bankConfig, accumulationFundEnum } from '../config.js'
import { sysInfoFn } from '@/api/org/per'
export default {
  components: {},
  props: {
    staffInfo: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      socialSatausConfig,
      taxDeductionConfig,
      accumulationFundEnum,
      bankConfig,
      min: 10,
      max: 10,
      sysInfo: {},
      taxStatus: {
        4: '2', // 预扣税 无需缴纳
        2: '2', // 不扣税 无需缴纳
        3: '1' // 个人所得税 正常缴纳
      }
    }
  },
  created() {
    this.getSysInfoFn()
  },
  methods: {
    getSysInfoFn() {
      sysInfoFn().then(res => {
        if (res && res.code === 1) {
          this.sysInfo = res.data
        }
      })
    },
    changeTaxDeduction(item) {
      // item 3个人所得税 4预扣税 2不扣税
      this.staffInfo.social_security_status = this.taxStatus[item]
      this.staffInfo.provident_fund_status = this.taxStatus[item]
      this.staffInfo.tax_rule = ''
      this.staffInfo.tax_rate = ''
      this.$emit('changeTax', item)
    },
    bankChange(val) {
      const item = this.bankConfig.find(i => i.value === val)
      if (!item) return
      this.min = item.minLength
      this.max = item.maxLength ? item.maxLength : item.minLength
      this.$emit('bankChange', this.min, this.max)
    },
    taxIdBlur(val) {
      this.$emit('taxIdBlur', val)
    }
  },
  watch: {
    'staffInfo.bank_name': {
      handler: function (val) {
        this.bankChange(val)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss">
.input-with-select {
  .el-input-group__prepend {
    background-color: #fff;
  }
  &.is-disabled {
    .el-input-group__prepend {
      background-color: #f5f7fa;
      color: #c0c4cc;
      .el-select {
        color: #c0c4cc;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.panel {
  overflow: hidden;
}
.divider {
  color: #262626;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
}
.icon {
  width: 16px;
  vertical-align: middle;
  margin-top: -4px;
  margin-left: 5px;
}
</style>
